<template>
  <section id="sso" style="height: 100vh"></section>
</template>
<script>
export default {
  data () {
    return {
      loading: true,
      error: null,
    };
  },
  mounted () {
    this.loading = false;
    this.login();
  },
  methods: {
    async getSettings () {
      await this.$http
        .get('/api/v1/systems')
        .then((response) => {
          this.settings = response.data;
          if (this.settings === '' || this.settings === null) {
            this.settings = Object.assign({}, this.defaultSettings);
          }
          this.$store.dispatch('setSettings', this.settings);
        })
        .catch((error) => {
          this.$store.dispatch('setSettings', this.defaultSettings);
        });
    },
    async login () {
      let sk = this.getURLParameter('sk');

      if (sk) {
        this.$http
          .post('/api/auth/ksdSlo', { sk: sk })
          .then((response) => {
            console.log(`response`, response);
            if (response.status === 200) {
              this.loginSuccess(response);
            }
          })
          .catch((error) => {
            console.log(`##### error : `, error);
            this.loading = false;
            this.error = error.response.data.error;
          });
      }
    },

    async loginSuccess (response) {
      this.$store.dispatch('setToken', response.data.token);
      this.$store.dispatch('setUser', response.data.user);

      this.$cookies.set('token', response.data.token, 60 * 60 * 9);
      this.$http.defaults.headers.common['Authorization'] =
        'Bearer ' + response.data.token;

      let path = `/kmeetingTb?userKey=${response.data.user.empNum}&sk=${this.getURLParameter('sk')}`;


      this.$router.replace(path);
      this.loading = false;
    },
    getURLParameter (sParam) {
      let sPageURL = window.location.search.substring(1);
      let sURLVariables = sPageURL.split('&');
      for (let i = 0; i < sURLVariables.length; i++) {
        let sParameterName = sURLVariables[i].split('=');
        if (sParameterName[0] === sParam) {
          return sParameterName[1];
        }
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/KsdSlo.vue